export default __webpack_public_path__ + "static/media/Thumbnail2.f114dfb5.png";